import axios, { Canceler } from 'axios'
import {
  ICreateLanguageDto,
  ILanguagesRespDto,
  IMessageResponseDto,
  ITranslationRespDto,
  IUpdateLanguageDto,
  IUpdateMissingTranslationsDto,
  IUpdateTranslationDto,
  IUpdateTranslationSwitchDto,
  ITranslationHelperStatusResDto,
} from 'src/types'
import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import { ETranslationType } from 'src/types/generate-localization.type'

class LanguagesService extends EnhancedWithAuthHttpService {
  CancelToken
  languagesCancel?: Canceler
  translationsCancel?: Canceler

  constructor() {
    super(new HttpService(axiosInstance))
    this.CancelToken = axios.CancelToken
  }

  getLanguages(params?: {}) {
    if (this.languagesCancel) {
      this.languagesCancel()
    }

    return this.get<ILanguagesRespDto>(`languages`, {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.languagesCancel = c
      }),
    })
  }

  getTranslations(params: {}) {
    if (this.translationsCancel) {
      this.translationsCancel()
    }

    return this.get<ITranslationRespDto>(`languages/translations`, {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.translationsCancel = c
      }),
    })
  }

  getTranslationHelperTextStatus(params: {}) {
    return this.get<ITranslationHelperStatusResDto>(`languages/translations/helper-text`, {
      params,
    })
  }

  createLanguage(dto: ICreateLanguageDto) {
    return this.post<IMessageResponseDto, ICreateLanguageDto>(`languages`, dto)
  }

  updateLanguage(dto: IUpdateLanguageDto) {
    return this.put<IMessageResponseDto, IUpdateLanguageDto>(`languages`, dto)
  }

  removeLanguages(ids: string[]) {
    return this.delete<IMessageResponseDto>(`languages`, { data: { ids } })
  }

  updateLanguageTranslation(dto: IUpdateTranslationDto) {
    return this.put<IMessageResponseDto, IUpdateTranslationDto>(`languages/translations`, dto)
  }

  updateLanguageTranslationSwitch(dto: IUpdateTranslationSwitchDto) {
    return this.put<IMessageResponseDto, IUpdateTranslationSwitchDto>(
      `languages/translations-switch`,
      dto,
    )
  }

  updateAITranslation(translationId: string, type: ETranslationType) {
    return this.put<string, null>(`languages/translations/ai/${translationId}/${type}`, null)
  }

  updateMissingTranslationsToAI(dto: IUpdateMissingTranslationsDto) {
    return this.put<string, IUpdateMissingTranslationsDto>(`languages/translations/missing`, dto)
  }

  checkNewSideLanguageTranslations() {
    return this.post<IMessageResponseDto, {}>(`crone-jobs/new-translations-check`, {})
  }
}

export const languagesService = new LanguagesService()

export default LanguagesService
